@let _option = option();

@switch (_option.type) {
  @case ('AUDIO') {
    @if (_option.size === 'SMALL') {
      <rid-audio-button #audioCard [src]="_option.src" size="SMALL" />
    } @else {
      <rid-audio-card #audioCard [src]="_option.src" [appearance]="appearance()" />
    }
  }
  @case ('CONTENT') {
    <rid-content-card
      #contentCard
      [text]="_option.text"
      [image]="_option.image"
      [audio]="_option.audio"
      [state]="appearance()"
      [layout]="_option.layout ?? 'VERTICAL'"
    />
  }
  @case ('RULE') {
    <rid-rule-card #contentCard [rule]="_option.rule" [appearance]="appearance()" />
  }
  @case ('SENTENCE') {
    <rid-labeled-card [label]="getLabel('Zin')" [mainText]="_option.sentence" />
  }
  @case ('WORD') {
    <rid-labeled-card [label]="getLabel('Woord')" [mainText]="_option.word" />
  }
  @default {
    <div class="font-extrabold text-red-500 italic">NOT SUPPORTED</div>
  }
}
